import styled from 'styled-components';

export const Container = styled.div`
  display: ${({ flex }) => (flex ? 'flex' : 'block')};
  flex-direction: ${({ flexDir, flex }) =>
    flexDir !== undefined && flex ? flexDir : null};
  justify-content: ${({ flex, justifyContent }) =>
    flex ? (justifyContent ? justifyContent : 'center') : null};
  align-items: ${({ flex, alignItems }) =>
    flex ? (alignItems ? alignItems : 'center') : null};
  width: ${({ width, fluid, theme }) =>
    fluid ? '100%' : width ? width : theme.media.lg};

  ${({ maxHeight, height }) =>
    maxHeight
      ? `height: ${maxHeight};`
      : `min-height: ${height ? height : 'auto'};`}

  margin: ${({ margin }) => (margin ? margin : '0 auto')};
  padding: ${({ padding }) => (padding ? padding : '0')};
  gap: ${({ gap }) => (gap ? gap : null)};
  /* Background params */

  background-color: ${({ bgColor }) => (bgColor ? bgColor : null)};
  background-blend-mode: ${({ bgBlend }) => (bgBlend ? bgBlend : null)};
  opacity: ${({ opacity }) => (opacity ? opacity : null)};
  color: ${({ color, theme }) => (color ? color : theme.colors.primaryColor)};

  @media (max-width: ${({ theme }) => theme.media.lg}) {
    width: 100%;
  }

  @media (max-width: ${({ flexWrap, theme }) =>
      flexWrap ? flexWrap : theme.media.md}) {
    flex-wrap: wrap;
  }
`;
